import React from 'react';
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";

// Loading spinner component
const Loader = () => (
  <div className="flex flex-col items-center justify-center py-4">
    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mb-2"></div>
    <p className="text-gray-600 text-sm">Loading PayPal...</p>
  </div>
);

const PayPalButton = ({ 
  amount, 
  currency, 
  onPaymentSuccess, 
  onPaymentError,
  cartItems,
  shippingMethod,
  subtotal,
  pointsDiscount,
  handleOrderSubmit // Add this prop
}) => {
  const [paymentError, setPaymentError] = React.useState(null);
  
  // PRODUCTION CLIENT ID
  const paypalClientId = "AS4enD6cbDrSqc6Yus5eg30fnidwNM4JiI7HevN_rHkDNZCrpz-xhvOxZaCNO99mJUQcolOEUO2U0cnJ";

  const PayPalButtonsWrapper = () => {
    const [{ isPending, isRejected }] = usePayPalScriptReducer();

    const createOrder = async (data, actions) => {
      try {
        const token = localStorage.getItem('AficFreshtoken');
        
        if (!token) {
          throw new Error('Authentication token not found');
        }
    
        const response = await fetch('https://afric-fresh-backend.onrender.com/order/create-paypal-order', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`  // Add the authorization header
          },
          body: JSON.stringify({
            amount: amount,
            currency: currency,
            items: cartItems
          })
        });
        
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || 'Failed to create PayPal order');
        }
    
        const orderData = await response.json();
        if (!orderData.id) {
          throw new Error('Invalid order ID received from server');
        }
        return orderData.id;
      } catch (error) {
        console.error('Order creation error:', error);
        setPaymentError(error.message || 'Failed to initialize payment. Please try again.');
        throw error;
      }
    };

    const onApprove = async (data, actions) => {
      try {
        const details = await actions.order.capture();
        handleOrderSubmit(details);
        return details;
      } catch (error) {
        console.error('Payment capture error:', error);
        setPaymentError('Payment processing failed. Please try again.');
        throw error;
      }
    };

    return (
      <>
        {isPending && <Loader />}
        {isRejected && (
          <div className="text-red-500 text-sm p-3 bg-red-50 rounded">
            Failed to load PayPal interface. Please refresh the page or try another payment method.
          </div>
        )}
        
        {!isPending && !isRejected && (
          <PayPalButtons
            style={{ 
              layout: "vertical",
              color: "blue",
              shape: "rect",
              label: "paypal",
              height: 48,
              tagline: false
            }}
            createOrder={createOrder}
            onApprove={onApprove}
            onError={(err) => {
              console.error('PayPal error:', err);
              setPaymentError('Payment processing error. Please try again.');
              onPaymentError(err);
            }}
            onCancel={() => setPaymentError("Payment cancelled by user")}
          />
        )}
      </>
    );
  };

  return (
    <PayPalScriptProvider 
    options={{ 
      "client-id": paypalClientId,
      currency: currency || "USD",
      "disable-funding": "credit,card",
      "merchant-id": "3AZVGCEVK2FZE",
      "intent": "capture",
      "commit": true,

    }}
    >
      <div className="mt-4">
        {paymentError && (
          <div className="mb-4 p-3 bg-red-50 text-red-500 rounded-md text-sm">
            {paymentError}
          </div>
        )}
        
        <PayPalButtonsWrapper />
      </div>
    </PayPalScriptProvider>
  );
};

export default PayPalButton;